/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_DateInputs */

const vi_weighing_date = /** @type {(inputs: Weighing_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cân`)
};

/**

* @param {Weighing_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_date = /** @type {((inputs?: Weighing_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_date(inputs)
});